;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var View = APP.module('View');
	var Model = APP.module('Model');
	View.SendToken = View.SendToken.extend({
		initialize: function(){
			this.errors = false;
			this.option = this.getOption('options');
			this.form = new Backbone.Form({
				template: JST.AflClubsSendToken,
				model: this.model
			});
			this.listenTo(this.form, 'email:change email:blur', this.changeAndBlur);
		}
	});

}(window, APP, Backbone, Marionette, $, _));